import React from 'react';
import { Surgerie } from 'types/surgerie';
import { Stack, Typography } from '@mui/material';
import DataGridList from 'components/data-grid/DataGridList';
import RowActionButton from 'components/data-grid/RowActionButton';
import StatusBadge from 'components/data-grid/StatusBadge';
import { reportSurgerieTableTemplate } from '../../template/reportSurgerieTableTemplate';
import ReportSurgerieMenu from '../menu/ReportSurgerieMenu';
import { useReportSurgerie } from '../../hooks/useReportSurgerie';

type ReportSurgerieListTableProps = {
  surgeries: Surgerie[];
};

const ReportSurgerieListTable: React.FC<ReportSurgerieListTableProps> = ({ surgeries }) => {
  const { anchorEl, setAnchorEl, setSelectedSurgerie } = useReportSurgerie();

  return (
    <>
      {anchorEl && <ReportSurgerieMenu anchorEl={anchorEl} />}

      <DataGridList
        template={reportSurgerieTableTemplate}
        rows={surgeries}
        getRowId={row => row.id}
        rowHeight={56}
        renderCells={{
          action: surgerie => (
            <RowActionButton
              onOpen={anchor => {
                setAnchorEl(anchor);
                setSelectedSurgerie(surgerie);
              }}
            />
          ),
          patientProcedure: surgerie => (
            <Stack sx={{ minWidth: 0 }}>
              <Typography variant="body2" color="primary" fontWeight={600} noWrap>
                {surgerie.formattedPatientName}
              </Typography>
              <Typography variant="caption" color="textSecondary" noWrap>
                {surgerie.formattedProcedureName}
              </Typography>
            </Stack>
          ),
          formattedTotalValue: surgerie => (
            <Stack sx={{ minWidth: 0, alignItems: 'flex-end' }}>
              <Typography variant="body2" color="primary" fontSize={16} fontWeight={700} noWrap>
                {surgerie.formattedTotalValue}
              </Typography>
              {surgerie.value_paid > 0 && (
                <Typography variant="caption" color="success.main" noWrap>
                  Pago: {surgerie.formattedValuePaid}
                </Typography>
              )}
            </Stack>
          ),
          formattedStatus: surgerie => <StatusBadge status={surgerie.status} label={surgerie.formattedStatus} />,
        }}
        exportValues={{
          patientProcedure: surgerie => `${surgerie.formattedPatientName} / ${surgerie.formattedProcedureName}`,
        }}
        fileName="relatorio_cirurgias"
        sheetName="Cirurgias"
      />
    </>
  );
};

export default ReportSurgerieListTable;
